// extracted by mini-css-extract-plugin
export default {"root":"order-book-view_root__XZ7DJ","ordersWrapper":"order-book-view_ordersWrapper__Q41Xe"};